function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSedimentPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 75,
    height: 75,
    viewBox: "0 0 19.84375 19.843751",
    id: "svg15374",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(0,-277.15624)"
  }, /*#__PURE__*/React.createElement("rect", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.20578705,
      strokeOpacity: 1
    },
    id: "rect4518-85-9-6",
    width: 19.84375,
    height: 19.84375,
    x: 3.5527137e-15,
    y: 277.15625
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#925214",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.17834876,
      strokeOpacity: 1
    },
    d: "m 1.3229134,278.47915 v 6.11384 c 2.142238,-0.0509 2.174441,-1.97972 4.258138,-1.97972 2.11146,0 2.55062,1.98437 4.34082,1.98437 1.8528406,0 2.2293506,-1.98437 4.3408206,-1.98437 2.083689,0 2.115899,1.92886 4.258138,1.97972 v -6.11384 z m 4.258138,6.08542 c -1.570228,0 -2.113637,1.92932 -4.258138,1.97972 v 3.01429 H 18.52083 v -3.01429 c -2.140466,-0.0506 -2.541545,-1.97972 -4.258138,-1.97972 -1.676731,0 -2.12457,1.98438 -4.3408206,1.98438 -2.21624,0 -2.74987,-1.98438 -4.34082,-1.98438 z m -4.258138,7.47448 v 3.63802 H 18.52083 v -3.63802 z",
    id: "rect4518-8-4-5-38-2-0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.16330439,
      strokeOpacity: 1
    },
    d: "m 17.684189,291.57912 -4.714442,4.71393 h 1.122929 l 4.713925,-4.71393 z",
    id: "rect8773-0-3-9"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.16330439,
      strokeOpacity: 1
    },
    d: "m 19.082035,293.17491 -3.085081,3.08506 h 1.12241 l 1.962671,-1.96265 z",
    id: "rect8773-0-3-5-5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.16330439,
      strokeOpacity: 1
    },
    d: "m 5.7102424,291.57912 -4.71392601,4.71393 H 2.1187294 l 4.713925,-4.71393 z",
    id: "rect8773-0-3-4-6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.16330439,
      strokeOpacity: 1
    },
    d: "m 8.7033414,291.57912 -4.713926,4.71393 h 1.123448 l 4.713406,-4.71393 z",
    id: "rect8773-0-3-5-23-4"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.16330439,
      strokeOpacity: 1
    },
    d: "m 11.697475,291.57912 -4.7139256,4.71393 h 1.122413 l 4.7139226,-4.71393 z",
    id: "rect8773-0-3-5-2-7-3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.16330439,
      strokeOpacity: 1
    },
    d: "m 14.690574,291.57912 -4.7139256,4.71393 h 1.1224126 l 4.713923,-4.71393 z",
    id: "rect8773-0-3-5-6-4-7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      display: "inline",
      opacity: 1,
      fill: "#ffffff",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.16330439,
      strokeOpacity: 1
    },
    d: "m 2.7171434,291.57912 -2.27531401,2.27532 v 1.12241 l 3.39772601,-3.39773 z",
    id: "rect8773-0-3-5-2-7-2-6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSedimentPoint);
export default __webpack_public_path__ + "static/media/icon-sediment-point.07f2e0d4567597769a332ff59304ee83.svg";
export { ForwardRef as ReactComponent };